var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "w-app",
        [
          _c(
            "w-toolbar",
            [
              _c(
                "w-toolbar-text",
                {
                  style: { textAlign: "center", width: "100%" },
                  attrs: { center: "" },
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _c("w-spacer"),
            ],
            1
          ),
          _c(
            "w-scroll-view",
            [
              _c(
                "w-container",
                {
                  style: {
                    maxWidth: "1140px",
                    margin: "0px auto",
                    flexGrow: 1,
                  },
                },
                [
                  _c(
                    "w-row",
                    [
                      _c("w-col", { attrs: { lg: "6", sm: "6", xs: "12" } }, [
                        _c("h1", [
                          _vm._v(
                            _vm._s(_vm.$ct("welcome")) + " " + _vm._s(_vm.name)
                          ),
                        ]),
                        _c("div", { staticClass: "header-info" }, [
                          _c("div", {
                            directives: [
                              {
                                name: "safe-html",
                                rawName: "v-safe-html",
                                value: _vm.parseTemplate(
                                  _vm.headerInfo,
                                  _vm.client
                                ),
                                expression: "parseTemplate(headerInfo,client)",
                              },
                            ],
                          }),
                        ]),
                      ]),
                      _c(
                        "w-col",
                        {
                          staticClass: "openWrap",
                          attrs: { lg: "6", sm: "6", xs: "12" },
                        },
                        [
                          _c("w-spacer"),
                          _vm.showTotalOpen
                            ? _c("div", { staticClass: "totalOpen" }, [
                                _c("div", [
                                  _vm._v(_vm._s(_vm.$ct("total-open"))),
                                ]),
                                _vm._v(" € " + _vm._s(_vm.totalOpen) + " "),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      !_vm.fetching
                        ? _c(
                            "w-col",
                            {
                              attrs: {
                                grow: "",
                                lg: "4",
                                shrink: "",
                                xl: "3",
                                xs: "12",
                              },
                            },
                            [
                              _c("app-invoice-list", {
                                staticClass: "invoice-list",
                                attrs: {
                                  config: _vm.config,
                                  "can-pay": _vm.canPayWithMollie,
                                  invoices: _vm.paidSales,
                                  "open-invoices": _vm.openSales,
                                  "expired-invoices": _vm.expiredSales,
                                  "open-estimates": _vm.openEstimates,
                                  "closed-estimates": _vm.closedEstimates,
                                  "active-invoice": _vm.activeInvoices,
                                  "show-estimates": _vm.showEstimates,
                                  "additional-sales": _vm.additionalSales,
                                  "signable-types": _vm.SignableTypes,
                                  token: _vm.token,
                                },
                                on: {
                                  fetch: function ($event) {
                                    return _vm.fetchData()
                                  },
                                  "invoice-clicked": function ($event) {
                                    return _vm.invoiceClicked($event)
                                  },
                                  "estimate-sign-clicked": function ($event) {
                                    ;(_vm.toSignSale = $event),
                                      _vm.showSignModale()
                                  },
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "created-box" }, [
            _c("div", { staticClass: "created" }, [
              _c("img", { attrs: { src: "/img/icons/128.png", width: "32" } }),
              _vm._v(" Created by Winfakt "),
            ]),
          ]),
          _c(
            "w-modal",
            {
              model: {
                value: _vm.signModalOpen,
                callback: function ($$v) {
                  _vm.signModalOpen = $$v
                },
                expression: "signModalOpen",
              },
            },
            [
              _vm.signModalOpen
                ? _c("app-sign-sale-modal", {
                    attrs: {
                      sale: _vm.toSignSale,
                      "e-token": _vm.singleSaleToken,
                    },
                    on: {
                      close: function ($event) {
                        _vm.signModalOpen = false
                      },
                      signed: _vm.fetch,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }